export interface PageInfo {
  currentPage: number
  totalPages: number
  totalCount: number
  openCount?: number | null
  closedCount?: number | null
}

export interface Label {
  color?: string
  description?: string
  id: number
  name: string
  nameHtml?: string
}

/**
 * Row metadata a viewer can click to filter the surrounding dashboard list.
 * Shared by issue and pull-request rows so the mixed list uses one contract.
 */
export type FilterSelectType = 'repo' | 'author' | 'label' | 'assignee'

export type FilterSelect = (type: FilterSelectType, value: string) => void

export type StateFilter = 'open' | 'closed'

export const DisplayMode = {
  Compact: 'compact',
  Default: 'default',
} as const

export type DisplayMode = (typeof DisplayMode)[keyof typeof DisplayMode]
